/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-zalo-oas';

export const EntityZaloOAApi = {
  find: async (option: any) => {
    const { body, ...param } = option;

    let url = `${pathname}/entity`;
    const query = serialize(param);
    url += query;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  genZaloKey: async (option: any) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkZaloOACanDelete: async (id: string) => {
    const url = `${pathname}/check-can-delete/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  confirmAccessToken: async (body: any) => {
    const url = `${pathname}/zalo/access-token`;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/entity/${id}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findZaloWithEntity: async (option: any) => {
    const { name, order, entityIDs, ...param } = option;

    let url = `${pathname}/find-with-entity`;
    const query = serialize(param);
    url += query;

    try {
      const response = await entityService.post(url, {
        entityIDs,
        order,
        name,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/entity/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
